/* ND FAQ Split — pill accordion */
(function () {
  "use strict";

  document.querySelectorAll("[data-faq2]").forEach((root) => {
    root.querySelectorAll(".faq2-q").forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest(".faq2-item");
        const isOpen = item.classList.contains("is-open");

        root.querySelectorAll(".faq2-item.is-open").forEach((o) => {
          if (o !== item) {
            o.classList.remove("is-open");
            o.querySelector(".faq2-q")?.setAttribute("aria-expanded", "false");
          }
        });

        item.classList.toggle("is-open", !isOpen);
        btn.setAttribute("aria-expanded", !isOpen ? "true" : "false");
      });
    });
  });
})();
